import { faEnvelope, faHouse, faInfoCircle, faMobile, faPhone } from '@fortawesome/pro-light-svg-icons'
import TwinToolTip from '../../../baseComponents/TwinToolTip'
import { CustomSelectProps, CustomSelectWithSearchBar } from '../../../forms/CustomSelect'
import { TwinDictionary } from '../../../utils/globals/dictionary'
import { parsePhoneNumber } from '../../../utils/globals/phone'
import DisplayTextWithCopy from '../../../baseComponents/Displays/DisplayTextWithCopy'

type CustomSelectCContactInfoProps = DisplayCustomerInfoToolTipProps & CustomSelectProps & {}

const CustomSelectCContactInfo: React.FC<CustomSelectCContactInfoProps> = ({ id, selectedContact, ...rest }) => {
    return (
        <div>
            {selectedContact ?
                <DisplayCustomerInfoToolTip {...{id, selectedContact}} />
                : null
            }
            <div id={'contact' + id}>
                <CustomSelectWithSearchBar {...rest} sortItems={true} />
            </div>
        </div>
    )
}

interface DisplayCustomerInfoToolTipProps {
    id: string
    selectedContact?: TwinDictionary
}

export const DisplayCustomerInfoToolTip: React.FC<DisplayCustomerInfoToolTipProps> = ({id, selectedContact}) => {
    return (
        <TwinToolTip place='top' anchorSelect={'#contact' + id} clickable className='max-w-300'>
            <div>
                <div>{selectedContact?.name}</div>
                <DisplayTextWithCopy icon={faHouse} text={selectedContact?.address} />
                <DisplayTextWithCopy icon={faPhone} text={parsePhoneNumber(selectedContact?.phone || '')} />
                <DisplayTextWithCopy icon={faMobile} text={parsePhoneNumber(selectedContact?.mobile || '')} />
                <DisplayTextWithCopy icon={faInfoCircle} text={selectedContact?.notes} />
                <DisplayTextWithCopy icon={faEnvelope} text={selectedContact?.email} />
            </div>
        </TwinToolTip>
    )
}

export default CustomSelectCContactInfo